<div>
	<ion-icon iconMode [name]="icon"></ion-icon>
	<p>{{ title }}</p>
</div>
